// extracted by css-extract-rspack-plugin
var _1 = "GBRqyDSYSlFZA3QtguZc9A--";
export { _1 as "closeButton" }
